var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"max-width":"1000px"}},[_c('h1',[_vm._v("Sivua ei löydy")])])
}
var staticRenderFns = []

export { render, staticRenderFns }